<template>
    <div>
        <div id="open-house" class="">
            <div class="title ">
                <h3 class="tracking-in-expand-fwd">{{ $t('open_house') }}</h3>
            </div>
            <div class="body flex-fill d-flex align-items-start slider">
                <div class="content-wrapper slide-in-right">
                    <!-- Your content goes here -->
                    <template v-for="subject in data">
                        <div class="open-house-subjects d-flex flex-column" :class="subject.subject_type">
                            <div class="open-house-subjects-title">
                                <h3>{{ subject.subject_name }}</h3>
                            </div>
                            <div class="open-house-items-wrapper">
                                <template v-for="item in subject.item">
                                    <div class="open-house-item" :class="{ 'lock': item.status == 'lock' }">
                                        <div ref="swirlItem" class="open-house-item-top" :class="{ 'shake-top': item.highlight == 'TRUE' }">
                                            <h3 class="open-house-item-top-title flex-fill d-flex justify-content-center align-items-center">
                                                {{ item.id }}
                                            </h3>
                                            <p class="open-house-item-top-desc d-flex justify-content-center align-items-center">{{ item.start_date }}</p>
                                        </div>

                                        <div class="open-house-item-bottom fade-in-top" :class="{ 'dropdown': item.item_type == 'lesson' || item.item_type == 'liveclass' || item.item_type == 'arena' }">
                                            <i class="item-status"></i>
                                            <div :id="'dropdown-lesson-' + item.item_id" :data-bs-toggle="item.item_type == 'lesson' || item.item_type == 'liveclass' || item.item_type == 'arena' ? 'dropdown' : ''" aria-expanded="false">
                                                <h5 class="open-house-item-bottom-title">{{ item.item_title }}</h5>
                                                <p class="open-house-item-bottom-desc">{{ item.item_desc }}</p>
                                                <a href="#" @click="item.status == 'unlock' ? gotoItem(item.item_id, item.item_type) : ''" v-if="item.item_type == 'battlegame'">
                                                    <img src="/themes/ito/images/open-house/sword_1.png" alt="">
                                                </a>
                                            </div>

                                            <div class="dropdown-menu open-house-item-dropdown" :class="item.item_type" :aria-labelledby="'dropdown-lesson-' + item.item_id" v-if="item.item_type == 'lesson' || item.item_type == 'liveclass' || item.item_type == 'arena'">
                                                <div class="dropdown-menu-header">
                                                    {{ item.objectives_title }}
                                                </div>
                                                <div class="dropdown-menu-body">
                                                    <img class="img-fluid" src="/themes/ito/images/open-house/arena_img.png" alt="" v-if="item.item_type == 'arena'">
                                                    <p v-html="item.objectives" v-else></p>
                                                </div>
                                                <div class="dropdown-menu-footer d-flex justify-content-end mt-3" v-if="item.status == 'unlock'">
                                                    <button class="ito-btn ito-btn-sm ito-btn-primary" @click="gotoItem(item.item_id, item.item_type)">Go to {{ item.item_type }}</button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { GOOGLE_API_KEY, GOOGLE_SHEET_ID } from "@/constant";
import { ErrorModal } from './';



export default {
    name: "OpenHouse",
    components: {
        ErrorModal,
    },
    data: () => ({
        data: {},
        grade: undefined,
        error: undefined
    }),
    mounted() {
        if (this.$route.query.grade) {
            this.grade = this.$route.query.grade;
            // Fetch data when component is mounted
            this.fetch();
        }
    },
    updated() {
        document.title = this.page_title;
        const slider = document.querySelector('.slider');
        let isDown = false;
        let startX;
        let startY;
        let scrollLeft;
        let scrollTop;
        if (slider) {
            slider.addEventListener("wheel", (e) => {
                e.preventDefault();
                const walk = e.deltaY * 1;
                slider.scrollLeft += walk;
            })
            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                startY = e.pageY - slider.offsetTop;
                scrollLeft = slider.scrollLeft;
                scrollTop = slider.scrollTop;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
                slider.classList.remove('active');
            });

            slider.addEventListener('mousemove', (e) => {
                if (!isDown) return;

                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const y = e.pageY - slider.offsetTop;
                const walk = (x - startX) * 1;
                const walktop = (y - startY) * 1;
                slider.scrollLeft = scrollLeft - walk;
                slider.scrollTop = scrollTop - walktop;
            });
        }
    },
    methods: {
        fetch() {
            // const sheetName = 'grade_' + this.grade;
            var url = "https://sheets.googleapis.com/v4/spreadsheets/" + GOOGLE_SHEET_ID + "/values/" + this.grade + "?key=" + GOOGLE_API_KEY + "";

            // Fetch data from API
            axios.get(url).then(response => {
                this.data = this.arrayToObj(response.data.values);
            }).catch(error => {
                console.error('Error fetching open house items:', error);

            });
        },


        arrayToObj(data) {
            //convert array from google spreadsheet(the first row is keys)
            var results = [];
            var dataObject = []
            var keys = data[0]
            data.forEach((row, x) => {
                if (x === 0) return; // skip header
                var item = {}
                row.forEach((key, i) => {
                    item[keys[i]] = key
                })
                dataObject.push(item)

            })
            var subjects = [...new Set(dataObject.map(item => item.subject_id))]
            subjects.forEach(subject_id => {
                var subject = {
                    subject_id: subject_id,
                    subject_type: dataObject.find(item => item.subject_id === subject_id).subject_type,
                    subject_name: dataObject.find(item => item.subject_id === subject_id).subject_name,
                    item: []
                };
                subject.item = dataObject.filter(item => item.subject_id === subject_id);
                results.push(subject)
            })
            return results;
        },
        async gotoItem(item_id, item_type) {
            var result = {
                "event": "go-to-" + item_type,
                "data": {}
            }
            if (item_type == 'lesson') {
                try {
                    const response = await axios.get('/lesson?id=' + item_id);
                    result.data = response.data.results;
                } catch (error) {
                    console.error(error);
                }
            }
            if (item_type == 'arena' || item_type == 'liveclass') {
                result.data = { url: item_id };
            }
            window.parent.postMessage(result, '*');
            if (typeof appHandler !== 'undefined') {
                appHandler.postMessage(JSON.stringify(result));
            }

        },


    },
}
</script>

<style scoped>
#open-house {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 100%;
    background: #FFFFFF;
    background-image: url('/public/themes/ito/images/open-house/openhouse_bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
}

#open-house .title {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 40px;
}

#open-house .title h3 {
    font-weight: 700;
    font-size: 3vw;
    color: var(--primary);
    text-transform: uppercase;
}

#open-house .body {
    padding: 0 60px;
    overflow-x: auto;
    margin-bottom: 10px;
}

#open-house .body .content-wrapper {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 60px;
    gap: 50px;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
}

#open-house .body .content-wrapper::before {
    content: '';
    position: absolute;
    left: 0;
    top: 201px;
    width: 100%;
    height: 4px;
    background-color: #EBEBEB;
    border-radius: 90em;
}

#open-house .body .content-wrapper .open-house-subjects-title {
    height: 62px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 20px;

}

#open-house .body .content-wrapper .open-house-subjects-title h3 {
    margin: 0;
}

.open-house-items-wrapper {
    display: flex;
    gap: 50px;
}

.open-house-item {
    display: flex;
    flex-direction: column;
    width: 84px;
    gap: 30px;
    align-items: center;
}

.open-house-item:hover .shake-top {
    animation: none;
}


.open-house-item-top {
    position: relative;
    width: 100%;
    height: 99px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0px 2px 4px 0px #00000026;

}

.open-house-item-top-title {
    font-size: 32px;
    font-weight: 700;
}

.open-house-item-top-desc {
    height: 31px;
    background: #FFFFFF;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    color: #31344D;
    border-radius: 0 0 8px 8px;
}

.open-house-item-bottom {
    position: relative;
    text-align: center;
}

.open-house-item-bottom:has(> .show) {
    z-index: 1;
}

.open-house-item-bottom::before {
    content: '';
    position: absolute;
    left: 50%;
    bottom: calc(100% + 10px);
    width: 2px;
    height: 20px;
    background-color: #EBEBEB;

}

.open-house-item-bottom.dropdown {
    cursor: pointer;
}

.item-status {
    content: '';
    position: absolute;
    left: calc(50% - 3px);
    top: -12px;
    width: 8px;
    height: 8px;
    background-color: #84E07C;
    border: 1px solid #49C24E;
    z-index: 1;
    border-radius: 90em;
}

.open-house-item.lock .item-status {
    content: url('data:image/svg+xml,<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z" fill="%23C3D4E5"/><path d="M14 27C21.1797 27 27 21.1797 27 14C27 6.8203 21.1797 1 14 1C6.8203 1 1 6.8203 1 14C1 21.1797 6.8203 27 14 27Z" fill="white"/><path opacity="0.2" d="M20.327 16.5854C20.327 16.507 20.327 16.4238 20.327 16.3455C20.327 16.37 20.3222 16.3944 20.3222 16.4189C20.2632 14.5293 19.4226 12.8404 18.1052 11.6558V8.64512H18.1003C17.9823 6.09465 15.8687 4.59668 13.2782 4.59668C13.1651 4.59668 13.052 4.59668 12.939 4.60647C12.9488 4.60647 12.9586 4.60647 12.9685 4.60647C10.5205 4.72396 8.56905 6.19256 8.45599 8.64023V12.2824C7.49746 13.4034 6.90759 14.8377 6.85844 16.4091C6.85844 16.3846 6.85352 16.3602 6.85352 16.3357C6.85352 16.414 6.85352 16.4923 6.85352 16.5756C6.85352 16.5854 6.85352 16.5902 6.85352 16.6C6.85352 16.6098 6.85352 16.6147 6.85352 16.6245C6.85352 20.3352 9.87165 23.3409 13.5976 23.3409C17.3236 23.3409 20.3418 20.3352 20.3418 16.6245C20.3418 16.6147 20.3418 16.6098 20.3418 16.6C20.3418 16.5902 20.3418 16.5854 20.3418 16.5756L20.327 16.5854ZM11.3218 6.73594C11.366 6.70167 11.4102 6.6772 11.4545 6.64783C11.4889 6.62335 11.5233 6.60377 11.5577 6.57929C11.6069 6.55481 11.6511 6.53034 11.7002 6.50586C11.7347 6.48628 11.774 6.47159 11.8084 6.45691C11.8625 6.43733 11.9165 6.41774 11.9706 6.39816C12.005 6.38837 12.0394 6.37369 12.0738 6.3639C12.1377 6.34431 12.2065 6.32963 12.2754 6.31494C12.2999 6.31005 12.3245 6.30026 12.354 6.29536C12.4474 6.27578 12.5408 6.2611 12.6391 6.2513C12.6785 6.24641 12.7227 6.24151 12.762 6.24151C12.9292 6.22683 13.1012 6.21704 13.2732 6.21704C14.974 6.21704 16.4536 6.9954 16.4389 10.29V10.5641C15.5688 10.1578 14.6053 9.9228 13.5829 9.9228C12.3049 9.9228 11.1202 10.2802 10.1027 10.897V10.29C10.1027 10.0844 10.1125 9.88854 10.1224 9.69762C10.1224 9.63398 10.1322 9.58013 10.1371 9.51649C10.1469 9.39411 10.1568 9.27662 10.1715 9.16403C10.1813 9.09549 10.1912 9.03675 10.201 8.96821C10.2158 8.87031 10.2305 8.7724 10.2502 8.68429C10.2649 8.62065 10.2797 8.5619 10.2944 8.49826C10.3141 8.41504 10.3337 8.33672 10.3534 8.25839C10.3681 8.19965 10.3878 8.1458 10.4075 8.08705C10.432 8.01852 10.4566 7.94509 10.4812 7.88145C10.5009 7.8276 10.5254 7.77865 10.5451 7.72969C10.5746 7.67095 10.5992 7.60731 10.6336 7.55346C10.6582 7.5094 10.6827 7.46535 10.7073 7.42129C10.7368 7.36744 10.7712 7.31848 10.8056 7.26953C10.8351 7.23037 10.8597 7.19121 10.8892 7.15204C10.9236 7.10799 10.9629 7.06393 10.9973 7.02476C11.0268 6.9905 11.0612 6.95623 11.0907 6.92686C11.13 6.8877 11.1694 6.85343 11.2136 6.81916C11.248 6.78979 11.2775 6.76531 11.3119 6.73594H11.3218Z" fill="%23595959"/><path d="M18.513 8.04844C18.395 5.49797 16.2813 4 13.6908 4C11.1003 4 8.98663 5.49308 8.86865 8.04844V14.3732H10.5252V9.68348C10.5498 6.25675 11.99 5.61057 13.6908 5.61057C15.3916 5.61057 16.8712 6.38892 16.8564 9.68348V14.3732H18.5179V8.04844H18.513Z" fill="%23CACCDD"/><path d="M13.0074 5.61084C11.3066 5.61084 9.86637 6.25702 9.8418 9.68376V14.3735H10.525V9.68376C10.5496 6.49689 11.7933 5.71364 13.3368 5.62063C13.2286 5.61574 13.1205 5.61084 13.0074 5.61084Z" fill="%239DA1BA"/><path d="M18.5134 8.04844C18.3954 5.49797 16.2817 4 13.6912 4C13.5782 4 13.4651 4 13.3521 4.00979C15.7853 4.13707 17.722 5.61057 17.8351 8.04844H17.84V14.3732H18.5232V8.04844H18.5183H18.5134Z" fill="%239DA1BA"/><path opacity="0.7" d="M9.55706 7.4464C9.66521 7.43171 9.72911 7.32402 9.77827 7.23101C10.0191 6.74637 10.2207 6.22257 10.609 5.84563C10.8007 5.65961 11.0268 5.51764 11.2529 5.38057C11.3512 5.32183 11.4692 5.2386 11.4643 5.12112C11.4643 5.00852 11.3463 4.92531 11.2333 4.92041C11.1202 4.92041 11.0121 4.96936 10.9138 5.02811C10.4025 5.32183 9.96997 5.73793 9.64554 6.22257C9.52265 6.40859 8.9672 7.53452 9.55706 7.4513V7.4464Z" fill="white"/><path opacity="0.7" d="M11.8327 4.97332C11.9507 5.01731 12.0883 4.99287 12.2161 4.96843C12.3488 4.944 12.4865 4.91467 12.6192 4.89023C12.7027 4.87557 12.7863 4.85602 12.86 4.81692C12.9338 4.77782 12.9878 4.70939 12.9878 4.63608C12.9878 4.56765 12.9338 4.50411 12.8699 4.4699C12.8011 4.43569 12.7224 4.42103 12.6438 4.41614C12.4127 4.39659 12.0785 4.42591 11.8868 4.55788C11.7393 4.65563 11.6017 4.89512 11.8376 4.97821L11.8327 4.97332Z" fill="white"/><path d="M20.0785 18.9466C21.692 15.6033 20.2786 11.5904 16.9215 9.98358C13.5644 8.37673 9.53496 9.78439 7.92147 13.1277C6.30798 16.4709 7.72145 20.4838 11.0785 22.0906C14.4356 23.6975 18.465 22.2898 20.0785 18.9466Z" fill="%23FFAE39"/><path d="M20.7392 15.749C20.6114 19.3471 17.6424 22.2256 14 22.2256C10.3575 22.2256 7.38855 19.3471 7.26074 15.749C7.26074 15.8273 7.26074 15.9057 7.26074 15.9889C7.26074 19.6996 10.2789 22.7053 14.0049 22.7053C17.7309 22.7053 20.749 19.6996 20.749 15.9889C20.749 15.9106 20.749 15.8273 20.749 15.749H20.7392Z" fill="%23E57828"/><path d="M17.896 17.1443C18.5163 14.9898 17.2654 12.7424 15.1021 12.1247C12.9387 11.5069 10.682 12.7526 10.0617 14.9071C9.44136 17.0616 10.6922 19.3089 12.8556 19.9267C15.019 20.5445 17.2756 19.2988 17.896 17.1443Z" fill="%23FFC050"/><path d="M14.5462 16.0035C14.7969 15.8322 14.964 15.5433 14.964 15.2153C14.964 14.6866 14.5314 14.2559 14.0005 14.2559C13.4697 14.2559 13.0371 14.6866 13.0371 15.2153C13.0371 15.5433 13.2042 15.8322 13.4549 16.0035L13.1059 17.5161C13.0715 17.6679 13.1846 17.8148 13.3419 17.8148H14.6543C14.8116 17.8148 14.9247 17.6679 14.8903 17.5161L14.5413 16.0035H14.5462Z" fill="%23994D1A"/><path d="M14.0005 15.6711C14.2828 15.6711 14.5117 15.4431 14.5117 15.1619C14.5117 14.8808 14.2828 14.6528 14.0005 14.6528C13.7181 14.6528 13.4893 14.8808 13.4893 15.1619C13.4893 15.4431 13.7181 15.6711 14.0005 15.6711Z" fill="%23E57828"/><path opacity="0.7" d="M13.3216 12.939C13.3609 12.9243 13.3954 12.8753 13.3855 12.8362C13.3757 12.8117 13.356 12.7921 13.3315 12.7774C13.2135 12.7089 13.0611 12.7383 12.9284 12.7774C12.3975 12.9439 11.9059 13.2425 11.5078 13.6341C11.2915 13.8446 11.0998 14.1041 11.0703 14.4027C11.1539 14.4516 11.2473 14.3537 11.3013 14.2656C11.5176 13.9083 11.8224 13.5999 12.1714 13.3698C12.545 13.1201 12.9284 13.0907 13.3216 12.9341V12.939Z" fill="white"/><path opacity="0.7" d="M11.0702 14.834C11.0752 14.8927 11.0506 14.9465 11.0309 15.0004C10.9768 15.1375 10.9424 15.2794 10.9277 15.4263C10.9228 15.4752 10.908 15.534 10.8589 15.534C10.8294 15.534 10.8048 15.5046 10.795 15.4801C10.7655 15.4067 10.7753 15.3235 10.7901 15.2501C10.8146 15.1081 10.8343 14.9661 10.8589 14.8242C10.8638 14.7899 10.8687 14.7605 10.8933 14.736C10.9572 14.6675 11.0702 14.7703 11.0801 14.834H11.0702Z" fill="white"/></svg>');
    position: absolute;
    left: calc(50% - 13px);
    top: -25px;
    width: 28px;
    height: 28px;
    z-index: 1;
    border: none;
    border-radius: 90em;
    background-color: transparent;
}

.open-house-item-bottom-title {
    font-size: 18px;
    font-weight: 700;
    color: #31344D;
    margin: 0;
}

.open-house-item-bottom-desc {
    font-size: 12px;
    font-weight: normal;
    text-align: center;
}

.math .open-house-item-top,
.math .open-house-subjects-title {
    background-color: #FF725E;
    color: #FFFFFF;
}

.science .open-house-item-top,
.science .open-house-subjects-title {
    background-color: #76CEBB;
    color: #FFFFFF;
}

.open-house-item-dropdown {
    width: 440px;
    background: #FFED61;
    border: 1px solid #ECD522;
    border-radius: 8px;
    padding: 14px;

}

.open-house-item-dropdown .dropdown-menu-header {
    color: #31344D;
    font-weight: 700;
    font-size: 20px;

}

.open-house-item-dropdown .dropdown-menu-body {
    color: #31344D;
    font-size: 14px;
}

.dropdown .open-house-item-bottom-title {
    text-decoration: underline
}

.arena {
    position: relative;
}

.arena {
    width: 173px !important;
}

.fade-in-top {
    -webkit-animation: fade-in-top 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
    animation: fade-in-top 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
}

@-webkit-keyframes fade-in-top {
    0% {
        -webkit-transform: translateY(-50px);
        transform: translateY(-50px);
        opacity: 0;
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes fade-in-top {
    0% {
        -webkit-transform: translateY(-50px);
        transform: translateY(-50px);
        opacity: 0;
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}




.tracking-in-expand-fwd {

    -webkit-animation: tracking-in-expand-fwd 0.8s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
    animation: tracking-in-expand-fwd 0.8s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
    animation-delay: 0.7s;
    -webkit-animation-delay: 0.7s;
}

@-webkit-keyframes tracking-in-expand-fwd {
    0% {
        letter-spacing: -0.5em;
        -webkit-transform: translateZ(-700px);
        transform: translateZ(-700px);
        opacity: 0;
    }

    40% {
        opacity: 0.6;
    }

    100% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
        opacity: 1;
    }
}

@keyframes tracking-in-expand-fwd {
    0% {
        letter-spacing: -0.5em;
        -webkit-transform: translateZ(-700px);
        transform: translateZ(-700px);
        opacity: 0;
    }

    40% {
        opacity: 0.6;
    }

    100% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
        opacity: 1;
    }
}

.slide-in-right {
    -webkit-animation: slide-in-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: slide-in-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

@-webkit-keyframes slide-in-right {
    0% {
        -webkit-transform: translateX(1000px);
        transform: translateX(1000px);
        opacity: 0;
    }

    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes slide-in-right {
    0% {
        -webkit-transform: translateX(1000px);
        transform: translateX(1000px);
        opacity: 0;
    }

    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
        opacity: 1;
    }
}

.shake-top {
    -webkit-animation: shake-top 1.6s cubic-bezier(0.455, 0.030, 0.515, 0.955) infinite both;
    animation: shake-top 1.6s cubic-bezier(0.455, 0.030, 0.515, 0.955) infinite both;
    animation-delay: 0.8s;
}

@-webkit-keyframes shake-top {

    0%,
    25%,
    100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transform-origin: 50% 0;
        transform-origin: 50% 0;
    }

    5% {
        -webkit-transform: rotate(2deg);
        transform: rotate(2deg);
    }

    10% {
        -webkit-transform: rotate(-4deg);
        transform: rotate(-4deg);
    }

    15% {
        -webkit-transform: rotate(4deg);
        transform: rotate(4deg);
    }

    20% {
        -webkit-transform: rotate(-2deg);
        transform: rotate(-2deg);
    }
}

@keyframes shake-top {

    0%,
    50%,
    100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transform-origin: 50% 0;
        transform-origin: 50% 0;
    }

    5%,
    45% {
        -webkit-transform: rotate(2deg);
        transform: rotate(2deg);
    }

    10%,
    20%,
    30% {
        -webkit-transform: rotate(-4deg);
        transform: rotate(-4deg);
    }

    15%,
    25%,
    35% {
        -webkit-transform: rotate(4deg);
        transform: rotate(4deg);
    }

    40% {
        -webkit-transform: rotate(-2deg);
        transform: rotate(-2deg);
    }


}
</style>